module.exports = __webpack_public_path__ + "img/funArena.854e6b38.png";